<template>
   <router-view />
</template>

<script lang="ts">
import utils from "@/utils/utils";
import { ElNotification } from 'element-plus';
import { defineComponent, provide} from "vue";
import { interfaceFunc } from "@/hooks/factoryFunc";
export default defineComponent({
   components: {
   },
   data() {
      return {};
   },
   setup(){

    const { getNewsDetail, getNewsList } = interfaceFunc(["getNewsDetail","getNewsList"]);
    /**
     * 获取今日消息提醒
     */
    const getNewsListToday = async () => {
      let result = await getNewsList({
        startDate:'',
        endDate:'',
        pageNum: 1,
        pageSize: 999,
        userCode: utils.$cookie.getCookie("hxUserCode"),
      });
      result.list.forEach((item:any)=>{
         if(!item.readStatus){
            setTimeout(()=>{
               let elNotifiObj = ElNotification({
                  title: '今日提醒',
                  message: item.content.replace('通知，',''),
                  type: 'success',
                  duration: 0,
                  onClose: ()=>{
                     readMessageFn(item)
                  }
               });
            },500);
         }
      });
    };
    const readMessageFn = (data:any)=>{
       getNewsDetail(data.id);
    }
    if(utils.$cookie.getCookie("hxUserCode") && utils.$cookie.getCookie("hxUserCode") !== '0'){
      getNewsListToday();
    }
   },
   mounted(){
      // window.addEventListener("beforeunload", e => {
      //    if (e) {
      //       e.returnValue = '关闭提示';
      //    }
      // });
   }
});
</script>

<style lang="less">
html,body{ height: 100%; position: relative; }
html body #app {
   background-color: #eff1f6;
   height: 100%;
   min-width: 1220px;
   font-family: PingFangSC, PingFangSC-Regular !important;
   font-size: 12px;
}
.title-column{ font-size: 16px;
    color: #222327;
    font-weight: 600;
    padding-bottom: 12px;
    position: sticky;
    z-index: 99;
    top: 0;
    background-color: #f5f7fd; }
.el-loading-spinner i{ font-size: 30px; color: #fff!important; }
.el-loading-spinner .el-loading-text{ color: #fff!important; padding-top: 10px; } 
.fixed-bottom{ position: fixed; bottom: 0; left: 226px; right: 0; z-index: 999; margin-bottom: 0; padding: 12px; border-top: 1px solid #e4e5ea; background: #fbfbfe; border-radius: 0px 0px 0px 32px; text-align: right; }
.blue-text{ color: #4680ff!important; }
.red-text{ color: #f56c6c!important; }
.green-text{ color: #67c23a!important; }
.yellow-text{ color: #e6a23c!important; }
.el-button{ min-height: 36px!important; padding: 8px 12px!important; }
// .el-input__inner{ height: 36px!important; line-height: 36px!important; }
// .el-form-item__label{ line-height: 30px!important; }
.el-input__suffix-inner{ position: relative; top: -2px; }
.el-button--text{ padding: 8px 0!important; }
.vxe-cell--title{ font-size: 12px; }
.el-input.is-disabled .el-input__inner{ color: #222327!important; }
.el-tag+.el-tag{ margin-left: 6px; }
.vxe-table--render-default{ font-size: 12px!important; }

// .el-input.is-disabled .el-input__inner{ color: #222327!important; background-color: inherit!important; border-color: #fff!important; padding: 0!important; text-align: left; border: none; }
// .el-input.is-disabled .el-input__suffix{ display: none; }
// .el-input.is-disabled .el-input__prefix{ display: none; }
// .el-range-editor.is-disabled{ color: #222327!important; }
// .el-textarea.is-disabled .el-textarea__inner{ color: #222327!important; background-color: inherit!important; border-color: #fff!important; padding: 0!important; resize: inherit!important; }
// .el-input-number.is-disabled .el-input-number__decrease, .el-input-number.is-disabled .el-input-number__increase{ display: none; }

.top-search-box { padding: 12px!important;
   .el-form-item { margin-bottom: 0!important; 
      .el-form-item__label{ line-height: 20px!important; }
      .el-input__inner{ height: 32px; line-height: 32px; }
      .el-range-separator{ line-height: 24px; }
   }
}
.el-form-item__label{ font-size: 12px!important; line-height: 20px!important; }
.el-form--label-top .el-form-item__label{ padding: 0!important; }
.el-form-item{ margin-bottom: 14px!important; }
.el-form-item--small.el-form-item{ margin-bottom: 14px!important; }
.el-button{ font-size: 12px!important; }

   // .el-form-item { margin-bottom: 0!important; 
   //    .el-form-item__label{ line-height: 30px!important; }
   //    .el-input__inner{ height: 32px; line-height: 32px; }
   //    .el-range-separator{ line-height: 24px; }
   // }
.require-header--column .vxe-cell--title{
   position: relative;
   &::before{
      content: '*';
      color: #f56c6c;
      position: absolute;
      left: -10px;
      top: 0;
   }
}
.notice-item{ font-size: 14px; }
.vxe-body--row:hover{ cursor: pointer; }
.router-warn-box{
  background-color: #e6a23c!important;
  color: #fff!important;
  .el-popover__title{
      color: #fff!important;
  }
  .el-popper__arrow{
      &::before{ 
         border-color: #e6a23c!important;
         background: #e6a23c!important;
      }
  }
}
.dr-item-box{ display: flex; justify-content: space-between; align-items: center;
   i{ margin-right: 0!important; display: none; font-weight: bolder; font-size: 16px; }
}
.dr-item-box:hover{
   i{display: inline-block; color: #F56C6C;}
}

.custorm-select{
  .el-select-dropdown__item{
   height: auto;
   line-height: inherit;
   background-color: #f1f1f1;
   margin-bottom: 2px;
   padding: 6px 32px 6px 20px;
   .custorm-select-content{
      h5{ font-size: 14px; font-weight: bolder; color: #000; margin-bottom: 6px; }
      p{ color: #999; font-size: 12px; }
   }
  }
}
</style>